import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styles from "./styles/ShoppingCart.module.css";
import { useWindowSize } from "@hooks";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartAction,
  deleteItemFromCartAction,
  handleCartAction,
} from "@redux/actions";
import { CartCard } from "@components/CourseCard/CartCard";
import clsx from "clsx";
import { getDiscountValid } from "@helpers";

const ShoppingCart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allCart } = useSelector((state) => state.orders);
  const { width } = useWindowSize();
  const [listId, setListId] = useState([]);

  useLayoutEffect(() => {
    dispatch(getCartAction());
  }, []);

  useEffect(() => {
    if (allCart && allCart.data) {
      setListId(
        allCart.data
          .filter((value) => value.isActive === true)
          .map((value) => {
            return value.course?.id;
          })
      );
    }
  }, [allCart.data]);

  // const checkDiscountValid = (discounts) => {
  //   let totalPercent = 0;
  //   discounts.map((value) => {
  //     if (
  //       moment().format("DD/MM/YYYY") >=
  //         moment(value.startDate).format("DD/MM/YYYY") &&
  //       moment().format("DD/MM/YYYY") <=
  //         moment(value.endDate).format("DD/MM/YYYY")
  //     ) {
  //       totalPercent += value.discountPercent;
  //     }
  //   });
  //   return totalPercent / 100;
  // };

  const listItem = (isActive) => {
    return (
      <>
        {allCart.data &&
        allCart.data.filter((value) => {
          return listId.includes(value.course?.id) === isActive;
        }).length > 0 ? (
          allCart.data
            .filter((value) => {
              return listId.includes(value.course?.id) === isActive;
            })
            .map((value) => {
              return (
                <div
                  className={clsx(styles.cardContainer)}
                  key={"course card " + value.course?.id}
                >
                  <div className={clsx("w-100")}>
                    <CartCard
                      variant={width > 576 ? "horizontal" : "vertical"}
                      data={{
                        id: value.course?.id,
                        title: value.course?.title,
                        thumbnailUrl: value.course?.thumbnailUrl,
                        category: value.course?.category,
                        price: value.course?.price,
                        priceDiscount:
                          value.course?.price -
                          value.course?.price *
                            getDiscountValid(value.course?.discounts),
                        author: value.course?.user ? value.course?.user : null,
                      }}
                      handleDelete={() => {
                        dispatch(
                          deleteItemFromCartAction({ itemId: value.course?.id })
                        );
                      }}
                      moveTo={() => {
                        return (
                          <button
                            onClick={() => {
                              // dispatch(
                              //   handleCartAction({
                              //     id: value.course?.id,
                              //     isActive: !value.isActive,
                              //   })
                              // );
                              if (
                                !isActive &&
                                !listId.includes(value.course?.id)
                              ) {
                                setListId([...listId, value.course?.id]);
                              } else {
                                setListId(
                                  listId.filter(
                                    (subValue) => subValue !== value.course?.id
                                  )
                                );
                              }
                              dispatch(
                                handleCartAction({
                                  id: value.course?.id,
                                  isActive: !isActive,
                                })
                              );
                            }}
                            className={clsx(styles.btnMove)}
                          >
                            <span>
                              {isActive ? "Save for Later" : "Move to Cart"}
                            </span>
                          </button>
                        );
                      }}
                    />
                  </div>
                </div>
              );
            })
        ) : allCart.data &&
          allCart.data.filter((value) => {
            return listId.includes(value.course?.id) === isActive;
          }).length === 0 ? (
          <h2 className="text-center">
            <b>
              {"Nothing in "}
              {isActive ? "cart" : "save for later"}
            </b>
          </h2>
        ) : (
          <div className={clsx("d-flex justify-content-center w-100")}>
            <Spinner animation="border" role="status" className="text-center">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
      </>
    );
  };

  return (
    <Container fluid className="p-0">
      <div className={clsx(styles.headerContainer)}>
        <Container className="py-4">
          <div>
            <Link to="/">Home</Link>
            <span> / Shopping Cart</span>
          </div>
          <h3 className="mt-4">Shopping Cart</h3>
        </Container>
      </div>
      <Container className={clsx("my-5")}>
        <div style={{ paddingBottom: "20px" }}>
          <span style={{ fontWeight: "bold" }}>
            {allCart.data && allCart.data.length > 0
              ? allCart.data.filter((value) => {
                  return listId.includes(value.course?.id) === true;
                }).length
              : 0}{" "}
            Course in Cart
          </span>
        </div>
        <Row className="g-4">
          <Col lg={8} className={clsx(styles.cartContainer)}>
            {listItem(true)}
            <span style={{ fontWeight: "bold" }}>Saved for later</span>
            {listItem(false)}
          </Col>

          <Col lg={4}>
            <div className={clsx("rounded border p-4", styles.courseCheckout)}>
              <div>Total</div>
              <div className="d-flex justify-content-between">
                <h6>Original Price</h6>
                <h6>
                  $
                  {allCart.data
                    ? allCart.data
                        .filter((value) => {
                          return listId.includes(value.course?.id);
                        })
                        .map((value) => {
                          return value.course?.price;
                        })
                        .reduce((x, y) => {
                          return x + y;
                        }, 0)
                    : 0}
                </h6>
              </div>
              <div className="d-flex justify-content-between">
                <h6>Discount Price</h6>
                <h6>
                  $
                  {allCart.data
                    ? allCart.data
                        .filter((value) => {
                          return listId.includes(value.course?.id);
                        })
                        .map((value) => {
                          return (
                            value.course?.price *
                            getDiscountValid(value.course?.discounts)
                          );
                        })
                        .reduce((x, y) => {
                          return x + y;
                        }, 0)
                    : 0}
                </h6>
              </div>
              <div className="d-flex justify-content-between">
                <h4>Total</h4>
                <h4>
                  $
                  {allCart.data
                    ? allCart.data
                        .filter((value) => {
                          return listId.includes(value.course?.id);
                        })
                        .map((value) => {
                          return value.course?.price;
                        })
                        .reduce((x, y) => {
                          return x + y;
                        }, 0) -
                      allCart.data
                        .filter((value) => {
                          return listId.includes(value.course?.id);
                        })
                        .map((value) => {
                          return (
                            value.course?.price *
                            getDiscountValid(value.course?.discounts)
                          );
                        })
                        .reduce((x, y) => {
                          return x + y;
                        }, 0)
                    : 0}
                </h4>
              </div>

              <Button
                className="w-100"
                disabled={listId.length !== 0 ? false : true}
                onClick={() => {
                  navigate("/checkout-course", {
                    state: {
                      courses: allCart.data
                        ? allCart.data.filter((value) => {
                            return listId.includes(value.course?.id);
                          })
                        : null,
                      // courseIds: listId,
                      // price: allCart.data
                      //   ? allCart.data
                      //       .filter((value) => {
                      //         return listId.includes(value.course?.id);
                      //       })
                      //       .map((value) => {
                      //         return value.course?.price;
                      //       })
                      //       .reduce((x, y) => {
                      //         return x + y;
                      //       }, 0) -
                      //     allCart.data
                      //       .filter((value) => {
                      //         return listId.includes(value.course?.id);
                      //       })
                      //       .map((value) => {
                      //         return (
                      //           value.course?.price *
                      //           checkDiscountValid(value.course?.discounts)
                      //         );
                      //       })
                      //       .reduce((x, y) => {
                      //         return x + y;
                      //       }, 0)
                      //   : 0,
                    },
                  });
                }}
              >
                Checkout Now
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

/* required: display name */
ShoppingCart.displayName = "ShoppingCart";

/* required: props types */
ShoppingCart.propTypes = {};

/* required: default props */
ShoppingCart.defaultProps = {};

export { ShoppingCart };
